import { coreApi } from '../../../api/config';
/**
  * Returns an object of arrays of invoices to submit by status
  *
  * The input array of currently selected invoices are split into 3 categories:
  * Invoices to be submitted to network lead, submitted to payer, or transmitted to payer.
  *
  * @param {Array} [array] The invoices currently selected in the Invoice Workqueue
  * @returns {Object} A object containing 3 arrays each representing invoice submission status
  */

const fetchBulkSubmitStatuses = async (selectedInvoices = [], isCboProvider) => {
  const submitToNetworkLeadIds = [];
  const submitToPayerIds = [];
  const transmitToPayerIds = [];
  let fetchPayerRecordByInvoice = [];

  if (isCboProvider) {
    const getNetworkLeadRelationships = selectedInvoices.map((invoice) => new Promise((resolve) => {
      resolve(
        coreApi.query(
          'network_lead_relationship',
          {
            provider: invoice.provider_id,
            fee_schedule: invoice.fee_schedule_id,
          },
        ),
      );
    }).then((response) => {
      if (invoice.network_lead && response.data.data.length > 0) {
        submitToNetworkLeadIds.push(invoice.id);
      } else {
        fetchPayerRecordByInvoice.push(invoice);
      }
    }));

    await Promise.all(getNetworkLeadRelationships);
  } else {
    // If network lead check payer record by invoice instead
    fetchPayerRecordByInvoice = [...selectedInvoices];
  }

  const getPayerOnInvoices =
    fetchPayerRecordByInvoice.map((invoice) => new Promise((resolve) => {
      resolve(
        coreApi.findRecord('payer', invoice.payer_id),
      );
  }).then((res) => {
    const payerRecord = res.data.data;

    if (payerRecord.payer_wq_interactive) {
      transmitToPayerIds.push(invoice.id);
    } else {
      submitToPayerIds.push(invoice.id);
    }
  }));

  await Promise.all(getPayerOnInvoices);

  return {
    submitToNetworkLeadIds,
    submitToPayerIds,
    transmitToPayerIds,
  };
};

export default fetchBulkSubmitStatuses;
